import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { loginApi } from "../helper/api_helper.js"
import web_logo from "../../src/assets/main_logo.png"
import banner_img from "../../src/assets/banner.jpg"
const SignInLayer = () => {
  const navigate = useNavigate()
  const [email,setEmail] = useState("")
  const [password,setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(true);

  const handleSignInClick = async ()=>{
    if(!email){
      toast.error("Please enter email")
      return
    }

    if(!password){
      toast.error("Please enter password")
      return
    }
    try {
      let payload = {
        email : email,
        password : password
      }
      
      let res = await loginApi(payload)
      // let res = await 
      
      if(res.status){
      
        localStorage.setItem("token", res.accessToken);
        localStorage.setItem("adminData", JSON.stringify(res.adminData));
        navigate("/dashboard")
      }
    } catch (error) {
      toast.error(error || "Login failed");
      
    }
  }
  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={banner_img} alt="" style={{height:"100%", objectFit:"cover"}} />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px d-flex" style={{marginLeft:"-20px"}}>
              <img src="/ship_logo.svg" alt="" />
            </Link>
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>
          <form action="#">
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <span
                onClick={() => setShowPassword((prev) => !prev)}
                className="toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
              >
                <i
                  className={showPassword ? "ri-eye-line" : "ri-eye-off-line"}
                ></i>
              </span>
            </div>
            <button
              type="button"
              onClick={handleSignInClick}
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-12"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
